<template>
  <div class="fts-accordion">
    <button class="fts-accordion__header" @click="toggle">
      <div class="fts-accordion__header-left">
        <slot name="title">
          <span class="fts-accordion__title">{{ title }}</span>
        </slot>
        <slot name="header-extra" />
      </div>
      <font-awesome-icon
        :icon="['fas', 'chevron-down']"
        class="fts-accordion__chevron"
        :class="{ 'fts-accordion__chevron--open': isOpen }"
      />
    </button>
    <fts-transition-expand>
      <div class="fts-accordion__body" v-if="isOpen">
        <slot />
      </div>
    </fts-transition-expand>
  </div>
</template>

<script>
import FTSTransitionExpand from './FTSTransitionExpand.vue';

export default {
  name: 'FTSAccordion',
  components: {
    'fts-transition-expand': FTSTransitionExpand
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    defaultOpen: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isOpen: this.defaultOpen
    };
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
      this.$emit('toggle', this.isOpen);
    }
  }
};
</script>

<style lang="scss">
.fts-accordion {
  background-color: #ffffff;
  border-radius: var(--inistate-rounded-8);
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
  padding: 16px;

  &__header {
    display: flex;
    align-items: center;
    width: 100%;
    cursor: pointer;
    background: none;
    border: none;
    padding: 8px;
    gap: 8px;
    text-align: left;

    &-left {
      display: flex;
      align-items: center;
      gap: 8px;
      flex: 1;
      min-width: 0;
    }
  }

  &__title {
    font-weight: var(--inistate-font-weight-medium);
    font-size: var(--inistate-paragraph-text-16);
    line-height: var(--inistate-paragraph-text-16--line-height);
    color: var(--inistate-text-secondary-color);
    white-space: nowrap;
  }

  &__chevron {
    flex-shrink: 0;
    color: var(--inistate-text-secondary-color);
    transition: transform 0.2s;

    &--open {
      transform: rotate(180deg);
    }
  }

  &__body {
    margin-top: 16px;
  }
}
</style>
